export enum ButtonStatusEnum {
  HIDDEN = 'hidden',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  SOON = 'soon',
  DONE = 'done',
}

export enum ExperienceDetailStatusEnum {
  DONE = 'done',
  IN_PROGRESS = 'in-progress',
  DISABLED = 'disabled',
  HIDDEN = 'hidden',
}
